<button mat-raised-button color="primary" *ngIf="refreshEnabled" (click)="button()" matTooltip="Reload">
    <mat-icon aria-label="Reload">{{ icon }}</mat-icon>
</button>